import { DefaultLoader } from 'components/Loaders/DefaultLoader';
import { SecurityAnimationLoader } from 'components/Loaders/SecurityAnimationLoader';

export const SECURITY_ANIMATION_LENGTH = 2000;

export const pageLoaderTypes = {
  DEFAULT: { name: 'DEFAULT', animationLength: 0, component: DefaultLoader },
  SECURITY_ANIMATION: {
    name: 'SECURITY_ANIMATION',
    animationLength: SECURITY_ANIMATION_LENGTH,
    component: SecurityAnimationLoader,
  },
};
